export * from './objekt-detail.component';
export * from './objekt-detail.component.module';